import './ModalClientCard.scss'
import {useEffect, useState, useRef} from 'react'
import moment from 'moment'
import {useTranslation} from 'react-i18next'
import {Button, Col, Icon, Modal, notification, Row, Spin, Switch, Table} from 'antd'
import {ModalPdfViewer} from '../../../InterestConflicts/components'
import {getC57FormHistoryPromise, getParamsPromise} from '../../../AdminParams/promises'
import {getClientDetailPromise, saveRegisterClientPromise, saveCommentsPromise} from '../../promises'
import {getRegionComunaPromise} from '../../../../promises'
import {getCountriesCodePromise} from '../../../OnBoarding/promises'
import {
  AnalisisRiesgo,
  CambioEstado,
  Comentarios,
  FichaCliente,
  InfoCdi,
  InvestigacionCdi,
  MonitoreoQuiebras,
  Relacionados,
  Servicios,
  UboFinder,
  Acciones
} from './components'
import { ActivityModal } from './components/FichaCliente/components'
import { ReportService } from '../../../../services'
import i18n from '../../../../config/i18next'
import { prepareCountriesForTenantSelectIsoHelper } from '../../../../helpers'

const ModalClientCard = ({item, handleCancel, currentUser, areas, users, parametersClient, onTitleButtons, showPdf=false}) => {
  const { t } = useTranslation()
  const [itemTable, setItemTable] = useState({status: 'ACTIVE', type: 'Person', category: 'CLIENTE', formularioInterno: true, subcliente: currentUser.subcliente, dateBirth: null, hasMonitoring: true});
  const itemTableRef = useRef(itemTable);
  const validateFields = useRef(null);
  const validateRelacionados = useRef(null);
  const [seeMore, setSeeMore] = useState(showPdf);
  const [record, setRecord] = useState(null);
  const [formId, setFormId] = useState(null);
  const [mode, setMode] = useState('new');
  const [countries, setCountries] = useState([]);
  const [repLegales, setRepLegales] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [regiones, setRegiones] = useState([]);
  const [comunas, setComunas] = useState([]);
  const [uboFinderParams, setUboFinderParams] = useState({});
  const [groups, setGroups] = useState([]);
  const [riskLocalStatus, setRiskLocalStatus] = useState(null);
  const [formDataComments, setFormDataComments] = useState(null);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isActivityModalActive, setIsActivityModalActive] = useState(false);
  const pdfContentRef = useRef(null);
  const forceExpandAll = showPdf;
  const riskLocalStatusRef = useRef(null);
  const relacionadosRef = useRef([]);

  useEffect(() => {
    riskLocalStatusRef.current = riskLocalStatus;
  }, [riskLocalStatus])

  useEffect(() => {
    relacionadosRef.current = repLegales;
  }, [repLegales])


  useEffect(() => {
    loadInit()
  }, [])

  const setValidateFields = (validateFn) => {
    validateFields.current = validateFn;
  }

  const setValidateRelacionadosFn = (validateFn) => {
    validateRelacionados.current = validateFn;
  }

  useEffect(() => {
    if (onTitleButtons && !isLoading) {
      const titleButtons = (
        <div className="modal-title-buttons">
          <div className="status-switch-wrapper">
            <span>{t('messages.aml.active')}:</span>
            <Switch 
              checked={itemTable.status === 'ACTIVE'} 
              disabled={mode === 'view' || mode === 'new' || mode === 'newFilled' || currentUser.type === 'AUDIT'} 
              onChange={(checked) => handleOnChange('status', checked ? 'ACTIVE' : 'INACTIVE')} 
            />
          </div>
          { itemTable.id && mode !== 'new' && mode !== 'newFilled' &&
          <Button 
            type="primary" 
            icon="file-pdf" 
            onClick={handleExportToPdf}
            loading={isGeneratingPdf}
            disabled={isGeneratingPdf}
          >
            {isGeneratingPdf ? 'Generando PDF...' : 'Exportar a PDF'}
          </Button>
          }
          { itemTable.id && mode !== 'new' && mode !== 'newFilled' &&
            <Button type="primary" onClick={handleActivityModal}>{t('messages.aml.activity')}</Button>
          }
          {mode &&
            getButtonsMode(mode)
          }
        </div>
      )
      onTitleButtons(titleButtons)
    }
  }, [itemTable?.id, itemTable?.status, isLoading, isGeneratingPdf, isSaving, mode])

  const refreshLocalRisk = (riskStatus) => {
    setRiskLocalStatus(riskStatus)
  }

  const loadInit = async () => {
    const raw = await getCountriesCodePromise()
    const paises = prepareCountriesForTenantSelectIsoHelper(raw, currentUser.cliente.pais)
    setCountries(paises)
    let client = item;
    let mode = 'edit' // view para modo lectura
    if(client.id === undefined) {
      client = { ...itemTable, ...client }
      if(item.type === undefined) {
        mode = 'new'
      }else {
        mode = 'newFilled'
        if(client.extId && client.rut) {
          if ((currentUser.cliente.pais === 'CHI' && client.pais !== 'CHI')
            ||
            (currentUser.cliente.pais === 'PER' && client.pais !== 'PER')
            ||
            (currentUser.cliente.pais === 'CR' && client.pais !== 'CR')
            ||
            (currentUser.cliente.pais === 'COL' && client.pais !== 'COL')
      ) {
            client.params = client.pais + '-' + client.rut
          }
        }
        if(client.iso3) {
          const p = paises.filter(p => p.iso3 === client.iso3);
          if(p && p.length === 1) {
            client.pais = p[0].country
          }
        }
      }
      const isAuthSearch = currentUser.cliente.modules.includes('AUTH-SEARCH') && !currentUser.modules.includes('OFCTO')
      let userAsig = currentUser
      if(isAuthSearch) {
        if(currentUser.cliente.oficialCto) {
          userAsig = currentUser.cliente.oficialCto
        }else {
          userAsig = currentUser.cliente.admin
        }
      }
      client.userAsig = {id: userAsig.id}

      setRepLegales([]);
      setItemTable(client)
    }else {
      await loadClient(paises)
    }
    setMode(mode)

    if(!parametersClient) {
      const params = await getParamsPromise()
      setUboFinderParams(params.ubofinder)
      setGroups(params.gruposNames)
    }else {
      setUboFinderParams(parametersClient.ubofinder)
      setGroups(parametersClient.gruposNames)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    itemTableRef.current = itemTable;
  }, [itemTable]);

  const handleSaveClient = ()  => {
    const isRelatedRowBlank = (row = {}) => {
      const v = (x) => (x == null ? '' : String(x)).trim()
      return (
        v(row.name) === '' &&
        v(row.tipoDoc) === '' &&
        v(row.dni) === '' &&
        v(row.type) === '' &&
        v(row.email) === ''
      )
    }

    const allRelated = Array.isArray(relacionadosRef.current) ? relacionadosRef.current : []
    const relatedToSave = allRelated.filter((r) => !isRelatedRowBlank(r))
    const invalidRelatedIdx = relatedToSave
      .map((r, i) => ({ idx: i + 1, r }))
      .filter(({ r }) => r.isValid === false)
      .map(({ idx }) => idx)

    if (invalidRelatedIdx.length > 0) {
      notification.error({
        message: t('messages.aml.notifications.anErrorOcurred'),
        description: `Relacionados con validación pendiente (ej. RUT inválido). Revisa las filas: ${invalidRelatedIdx.join(', ')}.`,
      })
      return
    }

    setIsSaving(true);
    let itemRecord = {...itemTableRef.current, repLegales: relatedToSave }
    if(riskLocalStatusRef.current) {
      itemRecord = {...itemRecord, ...riskLocalStatusRef.current}
    }
    saveRegisterClientPromise(itemRecord).then(response => {
      setIsSaving(false);
      if(response.status === 'OK') {
        notification.success({
          message: t('messages.aml.successfulOperation'),
          description: t('messages.aml.dataSavedSuccessfully')
        })
        if((mode === 'new' || mode === 'newFilled') && formDataComments) {
          formDataComments.append('formId', response.id)

          saveCommentsPromise(formDataComments).then(r => {
            handleCancel();
          });
        }else {
          handleCancel();
        }
      }else {
        notification.error({
          message: t('messages.aml.notifications.anErrorOcurred'),
          description: response.message
        })
      }
    })
  }

    // Lógica original de validación de FichaCliente
    const proceedWithFichaValidation = () => {
        if (validateFields && validateFields.current) {
            validateFields.current((err, values) => {
                if (!err) {
                    handleSaveClient()
                } else {
                    if (err.email) {
                        notification.error({
                            message: t('messages.aml.notifications.anErrorOcurred'),
                            description: `${t('messages.aml.emailNotValid')}${values && values.email ? `: ${values.email}` : ''}`
                        })
                    } else {
                        notification.error({
                            message: t('messages.aml.notifications.anErrorOcurred'),
                            description: t('messages.aml.missingRequiredField')
                        })
                    }
                }
            })
        } else {
            handleSaveClient();
        }
    }
  const handleValidateAndSaveClient = (e) => {
    e.preventDefault();
    // Validar Relacionados primero si existen
    if (validateRelacionados && validateRelacionados.current && repLegales.length > 0) {
      validateRelacionados.current((err) => {
        if (err) {
          notification.error({
            message: t('messages.aml.notifications.anErrorOcurred'),
            description: t('messages.aml.missingRequiredField')
          })
          return;
        }
        proceedWithFichaValidation();
      })
    } else {
      proceedWithFichaValidation();
    }
  }

  const handleEditClient = () => {
    setMode('edit')
  }

  const loadClient = async (paises) => {
    let record = await getClientDetailPromise(item.id)
    setItemTable(record.clCliente)
    setRecord(record)
    setRiskLocalStatus(null)

    let client = record.clCliente
    if(client.repLegales) {
        client.repLegales.map((rl) => {
        rl.isValid=true 
        rl.isNew=false
      })
      setRepLegales(client.repLegales)
    }

    if(!paises) paises = countries
    if(client.paisDir) {
      let pais = paises.filter(p => p.country === client.paisDir)
      if(pais && pais.length === 1) {
        pais = pais[0].iso2
        getRegionComunaPromise(pais).then((response) => {
          setRegiones(response)
          if(client.region) {
            let comunas = response.filter(e => e.name === client.region)
            if (comunas && comunas.length > 0){
              setComunas(comunas[0].comunas)
            }else{
              setComunas([])
            }
          }
        })
        }
    }
  }

  const handleRefreshItem = () => {
      loadClient()
  }

  const handlePdfViewer = (id) => {
    setFormId(id);
  }

  const onCancelPdfViewer = () => {
		setFormId(null);
  }

  const formsColumns = [
    {
      title: t("messages.aml.folio"),
      dataIndex: 'folio'
    },
    {
      title: t("messages.aml.request"),
      dataIndex: 'creationDate',
      sorter: (a, b) => a.creationDate - b.creationDate,
      render: (date) => {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    {
      title: t("messages.aml.status"),
      dataIndex: 'statusDecl',
      sorter: (a, b) => a.statusDecl < b.statusDecl,
      render: (status) => {
        return t("messages.aml.formKycStatus." + status)
      }
    },
    {
      title: t("messages.aml.statusDate"),
      dataIndex: 'statusDate',
      sorter: (a, b) => a.statusDate - b.statusDate,
      render: (date) => {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    {
      title: t("messages.aml.reminder"),
      dataIndex: 'lastReminder',
      render: (date, record) => {
        return date ? record.nroReminders+" - "+ moment(date).format('DD/MM/YYYY') : t("messages.aml.withoutReminder")
      }
    },
    {
      title: t("messages.aml.view"),
      dataIndex: 'id',
      render: (id, record) => {
        return record.statusDecl !== 'PENDIENTE' && <Icon type="file-pdf" onClick={ () => handlePdfViewer(id) } style={{fontSize: '20px'}}/>
      }
    }
  ]


  const handleOnChange = (key, value, item) => {
    if (key === 'type' && itemTable.id === undefined) {
      itemTable.processUF = false
      itemTable.formularioInterno = true
    }else if (key === 'paisDir') {
      if (item && item.props && item.props.code) {
        getRegionComunaPromise(item.props.code).then((response) => {
          setRegiones(response)
        })
      }else {
        setRegiones([])
      }
      setComunas([])
    }else if (key === 'region'){
      if (value && regiones){
        let comunas = regiones.filter(region => region.name === value)
        if (comunas && comunas.length > 0){
          setComunas(comunas[0].comunas)
        }else{
          setComunas([])
        }
      }
    }

    setItemTable({...itemTable, [key]: value})
  }

  const saveComments = (formData) => {
    setFormDataComments(formData)
  }

  const handleActivityModal = () => {
    setIsActivityModalActive(true)
  }

  const getButtonsMode = (mode) => {
    if(currentUser.type !== 'AUDIT') {
      if(mode === 'view') {
        return <Button type="primary" onClick={handleEditClient}>{ t('messages.aml.edit') }</Button>
      } else {
        return <Button type="primary" loading={isSaving} disabled={isSaving} onClick={handleValidateAndSaveClient}>{ t('messages.aml.save') }</Button>
      }
    }
    return null
  }

  const handleExportToPdf = async () => {
    setIsGeneratingPdf(true);
    await ReportService.read('/pdfRecord', {id: itemTable.id, lang: i18n.language}, {}, `Ficha_Registro_${itemTable.rut || itemTable.id}_${moment().format('YYYY-MM-DD')}.pdf`);
    setIsGeneratingPdf(false);
  }

    return (
      <div className="modClientCard">
        { isLoading ? 
          <Row style={{textAlign:'center', padding:700}}>
            <Spin size="large"/>
          </Row>
          :
          <>
            <div ref={pdfContentRef} id="record-pdf-content">
              <FichaCliente
                setValidateFn={setValidateFields}
                currentUser={currentUser}
                item={itemTable}
                origItem={item}
                handleOnChange={handleOnChange}
                countries = {countries}
                mode = {mode}
                groups= {groups}
                regiones={regiones}
                comunas={comunas}
                areas={areas}
                users={users}
                uboFinderParams={uboFinderParams}
                forceExpand={forceExpandAll}
              />
              { itemTable?.type === 'Entity' &&
                <Relacionados
                  currentUser={currentUser}
                  repLegales={repLegales}
                  setRepLegales={setRepLegales}
                  mode={mode}
                  countries={countries}
                  setValidateRelacionados={setValidateRelacionadosFn}
                />
              }
              { mode !== 'view' && (currentUser.cliente.modules.includes('QUIEBRA') || currentUser.cliente.modules.includes('ONBOARDING') || (itemTable.type === 'Entity' && currentUser.cliente.modules.includes('ADMCLI')) || currentUser.cliente.modules.includes('MONITOR-AML')) &&
                <Servicios
                  item={itemTable}
                  currentUser={currentUser}
                  handleOnChange={handleOnChange}
                  uboFinderParams={uboFinderParams}
                  loadClient = {loadClient}
                  key={Math.random()}
                />
              }
              { itemTable.category && !itemTable.id && (mode === 'new' || mode === 'newFilled') && (currentUser.cliente.modules.includes("CDI-FORM") || currentUser.cliente.modules.includes("ONBOARDING")) &&
                <Acciones
                    item={itemTable}
                    currentUser={currentUser}
                    handleOnChange={handleOnChange}
                    uboFinderParams={uboFinderParams}
                    loadClient = {loadClient}
                    key={Math.random()}
                />
              }
              {(mode === 'view' || mode === 'edit') &&
                <AnalisisRiesgo
                  record={record}
                  currentUser={currentUser}
                  handleRefreshItem = {handleRefreshItem}
                  setRiskLocalStatus = {refreshLocalRisk}
                  forceExpand={forceExpandAll}
                />
              }
              { (mode === 'view' || mode === 'edit') && (currentUser.cliente.modules.includes('ONBOARDING') || currentUser.cliente.modules.includes('CDI-FORM')) && currentUser.cliente.modules.includes('OFCTO') &&
                <CambioEstado
                  currentUser={currentUser}
                  itemTable={itemTable}
                  forceExpand={forceExpandAll}
                />
              }
              <Comentarios
                currentUser={currentUser}
                item={itemTable}
                saveComments={saveComments}
                forceExpand={forceExpandAll}
              />
              { (mode === 'view' || mode === 'edit') && currentUser.cliente.modules.includes('CDI-MATCH') && currentUser.modules.includes('CDI-MATCH') &&
                <InvestigacionCdi itemTable={itemTable} forceExpand={forceExpandAll}/>
              }
              {mode=== 'edit' && currentUser.cliente.modules.includes('CDI-FORM') && currentUser.modules.includes('CDI-FORM') &&
                <InfoCdi
                  item={itemTable}
                  forceExpand={forceExpandAll}
                />
              }
              {/* {(mode === 'view' || mode === 'edit') && currentUser.cliente.modules.includes('MONITOR') && currentUser.modules.includes('MONITOR') &&
                <Monitoreo
                  itemTable={itemTable}
                  currentUser={currentUser}
                />
              } */}
              {(mode === 'view' || mode === 'edit') && currentUser.cliente.modules.includes('QUIEBRA') && currentUser.modules.includes('QUIEBRA') && itemTable.hasQuiebras &&
                <MonitoreoQuiebras
                  itemTable={itemTable}
                  forceExpand={forceExpandAll}
                />
              }
              {itemTable?.type === 'Entity' && currentUser.cliente.modules.includes('ADMCLI')
                && uboFinderParams
                && ((itemTable.processUF  && !uboFinderParams.noInvestigaMalla)
                  ||
                  (!itemTable.formularioInterno && !uboFinderParams.sinFormulario))
                && (mode === 'view' || mode === 'edit') &&
                <UboFinder
                  itemRecord={record}
                  currentUser={currentUser}
                  uboFinderParams={uboFinderParams}
                  forceExpand={forceExpandAll}
                />
              }
              
              {(mode === 'view' || mode === 'edit') && itemTable.ficha && currentUser.cliente.modules.includes('ONBOARDING') && currentUser.modules.includes('ONBOARDING') &&
              <>
                <Row>
                  <Col span={22}>
                    <h3>{t('messages.aml.report.type.ONB')}</h3>
                  </Col>
                  <Col span={2} style={{textAlign:'right'}}>
                    <Button type="link" onClick={() => setSeeMore(!seeMore)}>
                      {seeMore ?
                        <>{t('messages.aml.seeLess')} <Icon type="minus"/></>
                        :
                        <>{t('messages.aml.seeMore')} <Icon type="plus"/></>
                      }
                    </Button>
                  </Col>
                </Row>
                <hr/>

                {seeMore &&
                  <div className={showPdf ? "" : "div-more-info"} style={{padding: 10}}>
                    <Row className="field-section-row">
                      <Col span={3}>
                        <div className="formCard-onb-modal">
                          {t('messages.aml.requests')} <br/>
                          {itemTable.ficha?.forms.length}
                        </div>
                      </Col>
                      <Col span={3}>
                        <div className="formCard-onb-modal">
                          {t('messages.aml.pending')} <br/>
                          {itemTable.ficha?.forms.filter(form => form.statusDecl === 'PENDIENTE').length}
                        </div>
                      </Col>
                      <Col span={3}>
                        <div className="formCard-onb-modal">
                          {t('messages.aml.completed')} <br/>
                          {itemTable.ficha?.forms.filter(form => form.statusDecl === 'EVALUACION').length}
                        </div>
                      </Col>
                      <Col span={3}>
                        <div className="formCard-onb-modal">
                          {t('messages.aml.authorized')} <br/>
                          {itemTable.ficha?.forms.filter(form => form.statusDecl === 'AUTORIZADA').length}
                        </div>
                      </Col>
                      <Col span={3}>
                        <div className="formCard-onb-modal">
                          {t('messages.aml.rejected')} <br/>
                          {itemTable.ficha?.forms.filter(form => form.statusDecl === 'RECHAZADA').length}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <Table
                          columns={formsColumns}
                          dataSource={itemTable.ficha?.forms}
                          pagination={!forceExpandAll && itemTable.ficha?.forms.length > 5 ? { pageSize: 5, size:"small" } : false}
                        />
                        {formId &&
                          <Modal
                            className="modal-pdf-viewer"
                            title="Formulario"
                            centered={true}
                            width={1000}
                            header={null}
                            footer={false}
                            onCancel={onCancelPdfViewer}
                            visible={true}
                          >
                              <ModalPdfViewer
                              pdfId={formId}
                              />
                          </Modal>
                        }
                      </Col>
                    </Row>
                  </div>
                }
              </>
              }
            </div>
          </>
          }
        {isActivityModalActive && 
          <Modal 
            visible
            width={1000}
            title={t('messages.aml.activities')}
            footer={false}
            onCancel={() => setIsActivityModalActive(false)}
          >
            <ActivityModal recordId={itemTable.id}/>
          </Modal>
        }
      </div>
    );
}
export default ModalClientCard;
